import React from 'react';

const AgentContext = React.createContext({});

export default AgentContext;
